export default __webpack_public_path__ + "static/630-22cea3af12dfb71d762e6e1a360cf919.jpg";